<template>
  <div>
    <b-modal id="modalEditIPzones" ref="modalEditIPzones" :title="$t('IP zone')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.id">
          <b-form-input type="text" v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name"/>
        </b-form-group>
        <b-row align-h="center">
          <md-button class="md-raised" @click="showModalSubnets">{{ $t('Add Subnets') }}</md-button>
        </b-row>
        <b-table striped hover small
          :items="editItem.networks"
          :fields="subnetsFields">
          <template v-slot:cell(actions)="row">
            <i @click.stop="ClickOnDeleteSubnetButton(row)" class="danger fa fa-trash-alt fa-lg" />
        </template>
        </b-table>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditIPzones')"/>
      </div>
    </b-modal>

    <b-modal hide-footer ref="modalSubnetsReferenceBook" id="modalSubnetsReferenceBook" :title="$t('Subnets')">
      <b-form-group label-align="right" :label="$t('Network')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" placeholder="192.168.1.0/24" v-model="newSubnets.network"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Gateway')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" placeholder="192.168.1.255" v-model="newSubnets.gateway"/>
      </b-form-group>

      <modal-ok-cancel @save="addSubnest" @cancel="$bvModal.hide('modalSubnetsReferenceBook')"/>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null,
    perPage: null
  },
  data () {
    return {
      deleteImage: require('@/assets/img/document_delete.png'),
      newSubnets: {
        'gateway': '',
        'network': '',
        'mask': ''
      },
      subnetsFields: [
        {key: 'network_prepared', label: this.$i18n.t('Network'), sortable: true},
        {key: 'gateway', label: this.$i18n.t('Gateway'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    addSubnest () {
      if (this.newSubnets.network.includes(':')) {
        if (!this.validationIPv6()) {
          return
        }
        if (!this.validationGatewayv6()) {
          return
        }
        this.newSubnets.mask = Number(this.newSubnets.network.split('/')[1])
        this.newSubnets.network_prepared = this.newSubnets.network.slice()
        this.newSubnets.network = this.newSubnets.network.split('/')[0]
        if (!Number(this.newSubnets.mask)) {
          this.newSubnets.mask = 128
        }
      } else {
        if (!this.validationIPv4()) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Is not valid ipv4 network'), 'Error')
          return
        }
        if (!this.validationGatewayv4()) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Is not valid ipv4 gateway'), 'Error')
          return
        }
        if (!this.validIpv4Mask()) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Is not valid ipv4 mask'), 'Error')
          return
        }
        let netValidation = this.validationIpv4Network(this.newSubnets.network.split('/')[0])
        if (!netValidation.ok) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Correct network is ') + ': ' + netValidation.network, 'Error')
          return
        }
        netValidation = this.validationIpv4Network(this.newSubnets.gateway)
        if (!netValidation.ok) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Gateway is not from network ') + ': ' + netValidation.network, 'Error')
          return
        }
        this.newSubnets.mask = Number(this.newSubnets.network.split('/')[1])
        this.newSubnets.network_prepared = this.newSubnets.network.slice()
        this.newSubnets.network = this.newSubnets.network.split('/')[0]
        if (!Number(this.newSubnets.mask)) {
          this.newSubnets.mask = 32
        }
      }
      this.editItem.networks.push(this.newSubnets)
      this.$refs.modalSubnetsReferenceBook.hide()
    },
    IPv4number (IPaddress) {
      var ip = IPaddress.match(/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/)
      if (ip) {
        let res = (+ip[1] << 24) + (+ip[2] << 16) + (+ip[3] << 8) + (+ip[4])
        return res
      }
      return null
    },
    intToIPv4 (int) {
      var part1 = int & 255
      var part2 = ((int >> 8) & 255)
      var part3 = ((int >> 16) & 255)
      var part4 = ((int >> 24) & 255)

      return part4 + '.' + part3 + '.' + part2 + '.' + part1
    },
    IPv4mask (maskSize) {
      return -1 << (32 - maskSize)
    },
    validIpv4Mask () {
      let mask = Number(this.newSubnets.network.split('/')[1])
      if (mask > 32 || mask < 0) {
        return false
      }
      return true
    },
    validationIpv4Network (address) {
      let net = this.newSubnets.network.split('/')[0]
      let mask = this.newSubnets.network.split('/')[1]
      let subnet = this.IPv4number(address) & this.IPv4mask(mask)
      return {ok: subnet === this.IPv4number(net),
        network: this.intToIPv4(subnet)
      }
    },
    validationIPv4 () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.newSubnets.network.split('/')[0].match(goodChars)) {
        return true
      } else {
        return false
      }
    },
    validationGatewayv4 () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.newSubnets.gateway.match(goodChars)) {
        return true
      } else {
        return false
      }
    },
    validationIPv6 () {
      let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
      if (this.newSubnets.network.split('/')[0].match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationGatewayv6 () {
      let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
      if (this.newSubnets.gateway.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect gateway format'), 'Error')
        return false
      }
    },
    ClickOnDeleteSubnetButton (row) {
      this.editItem.networks = this.editItem.networks.filter((value) => {
        return value !== row.item
      })
    },
    showModalSubnets () {
      this.newSubnets = {
        'gateway': '',
        'network': '',
        'mask': ''
      }
      this.$refs.modalSubnetsReferenceBook.show()
    },
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Name'), 'Error')
        return
      }
      if (this.editItem.networks <= 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Subnets table is empty'), 'Error')
        return
      }
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('ReferenceBooks/UPDATE_IP_ZONES', this.editItem)
        : this.$store.dispatch('ReferenceBooks/CREATE_IP_ZONES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          let perpage = this.perPage
          setTimeout(this.$store.dispatch, 500, 'ReferenceBooks/GET_IP_ZONES_PAGED', {page: 1, filter: '', perPage: perpage})
          this.$refs.modalEditIPzones.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/IPzone/editModal.vue